'use strict';

//Utility
var React = require('react');
var Formatter = require('../../utils/Formatter.js');
var _ = require('lodash');
//Actions
var SuperFirstTransferAction = require('../../actions/SuperFirstTransferAction.js');
var ApplicationAction = require('../../actions/ApplicationActions.js');
//Store
var SuperFirstTransferStore = require('../../stores/SuperFirstTransferStore.js').default;
var InSpecieTransferStore = require('../../stores/InSpecieTransferStore.js').default;
//Components
var SectionHeader = require('../Common/SectionHeader.jsx');
var RadioInput = require('../Common/RadioInput.jsx');
var InlineMessage = require('../Common/InlineMessage.jsx');
var UserNotification = require('../Common/UserNotification.jsx');
//Constants
var YesNoRadioData = require('../../constants/ApplicationConstants').YesNoRadioData;
var MessageTypes = require('../../constants/ApplicationConstants').messageTypes;
var YesNoValues = require('../../constants/ApplicationConstants').YesNoValues;

function getStateFromStores() {
    return {
        data: SuperFirstTransferStore.getFormModel(),
        isExternalRollOversOnly: SuperFirstTransferStore.getIsExternalRollOversOnly(),
        isInternalExternalRollOvers: SuperFirstTransferStore.getIsInternalExternalRollOversOnly(),
        isInternalAndInternalRollOvers: SuperFirstTransferStore.getIsInternalMoniesExternalMonies(),
        crossSectionDependencyMsg: SuperFirstTransferStore.getCrossSectionDependencyMsg(),
        inSpecieModel: InSpecieTransferStore.getInSpecieModel(),
        isUserNotificationClosed: false
    };
}

var SuperFirstTransferSection = React.createClass({
    getInitialState: function () {
        return getStateFromStores();
    },

    componentDidMount: function () {
        SuperFirstTransferStore.addChangeListener(this._onChange);
        InSpecieTransferStore.addChangeListener(this._onChange);
    },

    componentWillUnmount: function () {
        SuperFirstTransferStore.removeChangeListener(this._onChange);
        InSpecieTransferStore.removeChangeListener(this._onChange);
    },

    _onChange: function () {
        this.setState(getStateFromStores());
    },

    componentWillUpdate: function (nextProps, nextState) {
        if (nextState.data.isSuperTransferSetup !== this.state.data.isSuperTransferSetup) {
            ApplicationAction.sendIsSuperFirstTransfer(nextState.data.isSuperTransferSetup);
        }
    },

    onChangeSetupTransfer: function (e) {
        let fieldName = e.target.model,
            fieldValue = e.target.value;

        SuperFirstTransferAction.updateSuperFirstTransferData(fieldName, fieldValue);
    },

    getCrossSectionMsg: function () {
        var crossSectionMsg = Formatter.formatString(this.props.content.crossSectionParentText, { parentSection: this.props.content.superFirstTransfer.sectionHeader, sections: _.pluck(this.state.crossSectionDependencyMsg, 'content').join(', ') });

        return crossSectionMsg;
    },

    toggleUserNotificationClose: function () {
        this.setState({ isUserNotificationClosed: true, crossSectionDependencyMsg: this.state.crossSectionDependencyMsg.splice(0, this.state.crossSectionDependencyMsg.length) });
    },

    render: function () {
        if (!this.props.content) {
            return <div className="super-first-transfer-section">Loading...</div>;
        }

        var showSuperFirstTransferOption = this.state.isExternalRollOversOnly;
        var isBuySell = false;
        
        if(this.state.data.isRetirementBenefit && this.state.inSpecieModel && this.state.inSpecieModel.setUp && this.state.inSpecieModel.setUp === YesNoValues.NO)
        {            
            if(this.state.isInternalExternalRollOvers || this.state.data.ShowSuperFastForInternals )
            {
                showSuperFirstTransferOption =false; 
                isBuySell = true;
            }                     
        }
        
         
        var contextualMessage = '';
        var sftInlineMessage = this.state.data.sftInlineMessageRollover.concat('<br />')
            .concat(this.state.data.sftInlineMessageLink);

        if (this.state.data.downsizerContributionNotice) {
            sftInlineMessage = sftInlineMessage.concat('<br /><br />')
                .concat(this.state.data.downsizerContributionNotice);
        }

        if (this.state.data.isSuperTransferSetup === YesNoValues.YES) {
            contextualMessage = sftInlineMessage;
        }     
        return (
           <div className="super-first-transfer-section">
               { (this.state.data.nonInternalExists || isBuySell)  && !this.state.data.isDeathBenefit ?
                <section>
                    <SectionHeader focus={this.props.focus} sectionName={this.props.content.superFirstTransfer.sectionHeader} sectionHelpText={this.props.content.common.sectionHeaderHelp} NeedHelpInfo={this.props.content.superFirstTransfer.superFirstTransferHelp} />

                    <div className="container">
                        <UserNotification id="superFirstTransferUserNotification"
                                          message={this.getCrossSectionMsg()}
                                          onClick={this.toggleUserNotificationClose}
                                          isHidden={!this.state.crossSectionDependencyMsg.length || this.state.isUserNotificationClosed} />

                        { showSuperFirstTransferOption ?
                        <RadioInput id="sftSection"
                                    data={YesNoRadioData}
                                    model="isSuperTransferSetup"
                                    value={this.state.data.isSuperTransferSetup}
                                    label="Would you like to setup a SuperFirst Transfer?"
                                    onChange={this.onChangeSetupTransfer}
                                    contextualMessage={contextualMessage} /> :
                        <InlineMessage id="sftInlineMessage"
                                       type={MessageTypes.info}
                                       isHidden={false}
                                       customClass="contextual-space-separator"
                                       message={sftInlineMessage} /> }
                    </div>
                </section> : null }
           </div>
        );
    }
});

module.exports = SuperFirstTransferSection;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/SuperFirstTransfer/SuperFirstTransferSection.jsx